import { DetectionClass } from '@/utils/detection-classes';

const SIDEBAR_EVENT_FEED_VEHICLE_CLASS_IDS = [
    DetectionClass.CarVan,
    DetectionClass.Pickup,
    DetectionClass.Truck,
    DetectionClass.Bus,
] as const;

const SIDEBAR_EVENT_FEED_BAG_CLASS_IDS = [
    DetectionClass.Backpack,
    DetectionClass.DuffelBag,
    DetectionClass.Handbag,
    DetectionClass.Suitcase,
] as const;

export const SIDEBAR_EVENT_FEED_CLASS_IDS = [
    DetectionClass.Person,
    ...SIDEBAR_EVENT_FEED_VEHICLE_CLASS_IDS,
    ...SIDEBAR_EVENT_FEED_BAG_CLASS_IDS,
] as const;
